var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.96492 6.99995C8.96492 5.19293 10.193 3.96486 12 3.96486C13.807 3.96486 15.0351 5.19293 15.0351 6.99995C15.0351 8.80696 13.807 10.035 12 10.035C10.193 10.035 8.96492 8.80696 8.96492 6.99995ZM7.0351 6.99995C7.0351 9.73679 9.26317 11.9649 12 11.9649C14.7368 11.9649 16.9649 9.73679 16.9649 6.99995C16.9649 4.2631 14.7368 2.03503 12 2.03503C9.26317 2.03503 7.0351 4.2631 7.0351 6.99995ZM3.96492 17.9999C3.96492 16.421 7.24562 14.9649 12 14.9649C16.7544 14.9649 20.0351 16.421 20.0351 17.9999C20.0351 19.2456 19.2456 20.035 18 20.035H6.00001C4.75439 20.035 3.96492 19.2456 3.96492 17.9999ZM2.0351 17.9999C2.0351 20.1754 3.82457 21.9649 6.00001 21.9649H18C20.1754 21.9649 21.9649 20.1754 21.9649 17.9999C21.9649 15.0175 17.3158 13.035 12 13.035C6.68422 13.035 2.0351 15.0175 2.0351 17.9999Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonOutlined);
export default __webpack_public_path__ + "static/media/person_outlined.ca3d0988.svg";
export { ForwardRef as ReactComponent };